import { useEffect } from "react";
import { LoadingAIForm } from "./helpers/LoadingAIForm";
import useParseAi from "hooks/useParseAi";
import { Box, Divider, Stack, Typography } from "@mui/material";
import LeftTabsContainer from "./form/LeftTabsContainer";
import RightTabsContainer from "./form/RightTabsContainer";
import { useSelector } from "react-redux";

export default function SecondStep({
    setIsDialogClosed,
}) {
    const candidate = useSelector((state) => state.currentCandidate);
    const { isLoading: isParseLoading, isSubmitSuccess: isParseSuccess, parseAiData, getParsedAIDataFromLocalStorage } = useParseAi();

    useEffect(() => {
        if (!candidate.id) {
                return;
            }

        if (localStorage.getItem(`currentCandidateAI-${candidate.id}`)) {
           return getParsedAIDataFromLocalStorage(candidate.id);
        }
        const fetchData = async () => {
            await parseAiData(candidate.id);
        };

        fetchData();
    }, [parseAiData, candidate.id, getParsedAIDataFromLocalStorage]);

    return (
        <>
            {isParseLoading && <LoadingAIForm />}
            {!isParseLoading && isParseSuccess && (
                <Stack
                    gap={0}
                    alignItems="center"
                    flexDirection={"row"}
                    sx={{
                        width: "100%",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "center",
                            width: "50%",
                            height: "85vh",
                        }}
                    >
                        <LeftTabsContainer />
                    </Box>
                    <Divider orientation="vertical" flexItem />
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "50%",
                            height: "85vh",
                        }}
                    >
                        <RightTabsContainer setIsDialogClosed={setIsDialogClosed} candidateId={candidate.id} />
                    </Box>
                </Stack>
            )}

                {!isParseLoading && !isParseSuccess && (
                    <Box mt={3} px={4} mb={4}>
                        <Stack gap={2}>
                            <Typography variant="body1" mb={1}>
                                It seems there was an issue parsing the candidate data with AI. Please try again.
                            </Typography>
                        </Stack>
                    </Box>
                )}

        </>
    );
}
